import { render } from "./InvestigationTree.vue?vue&type=template&id=3e603f98&scoped=true"
import script from "./InvestigationTree.vue?vue&type=script&lang=js"
export * from "./InvestigationTree.vue?vue&type=script&lang=js"

import "./InvestigationTree.vue?vue&type=style&index=0&id=3e603f98&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e603f98"]])

export default __exports__